import AppGrid from './AppGrid';

function AppRow(props) {
  return <AppGrid {...props} name='row' />
}

export default AppRow;
